import { atomWithKey as atom } from "./atomWithKey";
import {
    ICorporateResponse,
    ICorporateUser,
} from "../Types/Interface/ICorporate";


export const activitiesSectorsAtom = atom<any[]>({
    key: "activitiesSectorsAtom",
    default: [],
});

export const citiesAtom = atom<any[]>({
    key: "citiesAtom",
    default: [],
});

export const requestCorporateAccountDetailsAtom = atom<any>({
    key: "requestCorporateAccountDetailsAtom",
    default: {},
});
export const corporateFormSubmittedAtom = atom<boolean>({
    key: "corporateFormSubmittedAtom",
    default: false,
});
/**
 * ---------------------------------------------------------------------------
 * My Company Account (the admin-facing company section)
 * ---------------------------------------------------------------------------
 */

/** The company loaded from GET /corporates/{id}; null until it resolves. */
export const corporateDataAtom = atom<ICorporateResponse | null>({
    key: "corporateDataAtom",
    default: null,
});

/** Members from GET /corporates/{id}/users. */
export const corporateUsersAtom = atom<ICorporateUser[]>({
    key: "corporateUsersAtom",
    default: [],
});

/**
 * "" is the landing view with the five tiles; any other value selects a panel.
 * Mirrors activeAccountActionAtom on /my-account.
 */
export const activeCompanyActionAtom = atom<string>({
    key: "activeCompanyActionAtom",
    default: "",
});

/** True while the company is being fetched, so panels can show a loader. */
export const corporateLoadingAtom = atom<boolean>({
    key: "corporateLoadingAtom",
    default: false,
});

/** Set when the company fetch fails, so panels show an error, not an empty form. */
export const corporateLoadErrorAtom = atom<boolean>({
    key: "corporateLoadErrorAtom",
    default: false,
});

/** Set when the employees fetch fails, so the panel can tell an empty roster
 *  apart from a refused request. */
export const corporateUsersLoadErrorAtom = atom<boolean>({
    key: "corporateUsersLoadErrorAtom",
    default: false,
});

/** Employees Bookings rows currently loaded. */
export const companyBookingsAtom = atom<any[]>({
    key: "companyBookingsAtom",
    default: [],
});

export const companyBookingsTotalAtom = atom<number>({
    key: "companyBookingsTotalAtom",
    default: 0,
});

export const companyBookingsLoadingAtom = atom<boolean>({
    key: "companyBookingsLoadingAtom",
    default: false,
});

/** Set when the booking search fails or cannot be scoped to a company. */
export const companyBookingsLoadErrorAtom = atom<boolean>({
    key: "companyBookingsLoadErrorAtom",
    default: false,
});

/** Roster size reported by the API, which can exceed the loaded page. */
export const corporateUsersTotalAtom = atom<number>({
    key: "corporateUsersTotalAtom",
    default: 0,
});
